import '@/App.css';
import RouteProvider from '@/routes/index';
import { ThemeProvider } from '@/contexts/Theme';

function App() {
  return (
    <div className='App'>
      <ThemeProvider>
        <RouteProvider></RouteProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
